<template>
  <div>
    <br /><br />
    <div :class="custom_loader ? '' : 'custom-alignment '">
      <!-- <loading-progress
        :progress="50"
        indeterminate="indeterminate"
        :counter-clockwise="false"
        :hide-background="true"
        size="150"
        rotate
        fillDuration="2"
        rotationDuration="1"
      /> -->
      <img src="../../../public/assets/loader80.gif" alt="" :class="custom_loader ? '' : 'custom-size-class'" :width="width" :height="height">
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  props: ["width", "height", "custom_loader"],
};
</script>

<style scoped>
@import "../../../node_modules/vue-progress-path/dist/vue-progress-path.css";

@media only screen and (max-width: 600px) {
  .custom-size-class {
    width: 50%;
  }

  .custom-alignment {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
    color: rgba(12, 15, 102, 1);
  }
}
@media only screen and (min-width: 601px) {
  .custom-size-class {
    height: 300px;
    width: 300px;
  }

  .custom-alignment {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
    color: rgba(12, 15, 102, 1);
  }
}
</style>
